var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    _vm._l(_vm.locales, function(locale) {
      return _c("text-input", {
        key: locale,
        attrs: {
          value: _vm.innerValue[locale],
          name: _vm.name + "_" + locale,
          title: _vm.title + " " + locale,
          multiple: _vm.multiple,
          rows: _vm.rows,
          "max-length": _vm.maxLength,
          counter: !!_vm.maxLength
        },
        on: {
          input: function($event) {
            return _vm.setFieldInput($event, locale)
          }
        }
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-56a60e20", { render: render, staticRenderFns: staticRenderFns })
  }
}